import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { CustomersTyresPage } from '@/features/customers-tyres/customers-tyres-page';

/** The tyre hotel's customers ("Kunder dækhotel"). The list requires `customer-tyres:read`. */
export const Route = createFileRoute('/_app/customers/tyres')({
  staticData: { featureKey: 'customers-tyres' },
  beforeLoad: ({ context, location }) =>
    requireFeature(context, location, {
      feature: 'customers-tyres',
      permissions: ['customer-tyres:read'],
    }),
  component: CustomersTyresPage,
});
